import { render, staticRenderFns } from "./MeasureTypeList.vue?vue&type=template&id=30208aa5&scoped=true"
import script from "./MeasureTypeList.vue?vue&type=script&lang=js"
export * from "./MeasureTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30208aa5",
  null
  
)

export default component.exports